const actions = {
  GET_MONITOR_LOAD: 'GET_MONITOR_LOAD',
  GET_MONITOR_SUCCESS: 'GET_MONITOR_SUCCESS',
  GET_MONITOR_ERROR: 'GET_MONITOR_ERROR',

  getLoad: () => {
    return { type: actions.GET_MONITOR_LOAD };
  },
  getSuccess: (monitor) => {
    return { type: actions.GET_MONITOR_SUCCESS, monitor };
  },
  getErr: (err) => {
    return { type: actions.GET_MONITOR_ERROR, err };
  },

  ADD_MACHINE_BEGIN: 'ADD_MACHINE_BEGIN',
  ADD_MACHINE_SUCCESS: 'ADD_MACHINE_SUCCESS',
  ADD_MACHINE_ERROR: 'ADD_MACHINE_ERROR',

  addMachineBegin: () => {
    return { type: actions.ADD_MACHINE_BEGIN };
  },

  addMachineSuccess: (machines) => {
    return { type: actions.ADD_MACHINE_SUCCESS, machines };
  },

  addMachineErr: (err) => {
    return { type: actions.ADD_MACHINE_ERROR, err };
  },

  GET_MACHINE_DATA_LOAD: 'GET_MACHINE_DATA_LOAD',
  GET_MACHINE_DATA_SUCCESS: 'GET_MACHINE_DATA_SUCCESS',
  GET_MACHINE_DATA_ERROR: 'GET_MACHINE_DATA_ERROR',

  getMachineDataLoad: () => {
    return { type: actions.GET_MACHINE_DATA_LOAD };
  },
  getMachineDataSuccess: (raw) => {
    return { type: actions.GET_MACHINE_DATA_SUCCESS, raw };
  },
  getMachineDataErr: (err) => {
    return { type: actions.GET_MACHINE_DATA_ERROR, err };
  },

  GET_EXCEL_LOAD: 'GET_EXCEL_LOAD',
  GET_EXCEL_SUCCESS: 'GET_EXCEL_SUCCESS',
  GET_EXCEL_ERROR: 'GET_EXCEL_ERROR',

  getExcelLoad: () => {
    return { type: actions.GET_EXCEL_LOAD };
  },
  getExcelSuccess: () => {
    return { type: actions.GET_EXCEL_SUCCESS };
  },
  getExcelErr: (err) => {
    return { type: actions.GET_EXCEL_ERROR, err };
  },
};

export default actions;
